import React from 'react';
import { cn } from '../../lib/utils';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const ColorInput = ({ label, value, onChange, placeholder, colors, srDefault }) => (
  <div className="space-y-1.5">
    {label && <Label className="text-xs">{label}</Label>}
    <div className="flex items-center gap-2">
      <input
        type="color"
        value={value || srDefault || '#cccccc'}
        onChange={(e) => onChange(e.target.value)}
        className="w-8 h-8 rounded cursor-pointer border-0 p-0"
      />
      <Input
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || 'SR default'}
        className={cn("flex-1 h-8 text-xs font-mono", colors?.bgSecondary)}
      />
    </div>
  </div>
);
